module.exports = __webpack_public_path__ + "static/img/xm4.37b0a4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/commonproblem/nobindmsg/xm/xm4.png
// module id = AKci
// module chunks = 0